import { memo, ReactNode } from 'react'
import Box from '@mui/material/Box'

const boxStyles = {
	p: '2%',
	opacity: '0.7',
	fontSize: '1.2rem',
	textAlign: 'center',
	borderRadius: '8px',
	backgroundColor: '#0000000A'
}

interface NoDataProps {
	content?: string | ReactNode
}

export const NoData = memo(function NoData(props: NoDataProps) {
	const { content = 'No data' } = props

	return (
		<Box
			sx={boxStyles}
		>
			{content}
		</Box>
	)
})